import React, { useState } from "react";
import './autodashboard.css'
import { Card, Table } from "antd";
import { RecentAutoData } from "../../../data";
import { InfoCircleOutlined, MoreOutlined } from "@ant-design/icons";
const AutoDashboard = ({allUploadFiles}) => {
  const [recentPagination,setRecentPagination] = useState(10)
  const [pagination,setPagination] = useState(10)
  const columns = [
    {
      title: "File Name",
      dataIndex: "FileName",
      key: "FileName",
      // sorter: true,
    },
    {
      title: "Uploaded By",
      dataIndex: "UploadedBy",
      key: "UploadedBy",
      // sorter: true,
    },
    {
      title: "Upload Time",
      dataIndex: "UploadedAt",
      key: "UploadedAt",
      render: (text) => {
      const date = new Date(text);
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (1–12)
      const day = String(date.getDate()).padStart(2, "0");        // Day (1–31)
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
      },

      // sorter: true,
    },
    {
      title:"File Type",
      dataIndex:"FileType",
      key:"FileType",
      // sorter:true
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      // sorter: true,
    },
  ];

  const currentDate = new Date();
const currentMonth = currentDate.getMonth();
const currentYear = currentDate.getFullYear();

const currentMonthData = (allUploadFiles || []).filter(item => {
  const uploadedDate = new Date(item.UploadedAt);
  return (
    uploadedDate.getMonth() === currentMonth &&
    uploadedDate.getFullYear() === currentYear
  );
});

const previousMonthsData = (allUploadFiles || []).filter(item => {
  const uploadedDate = new Date(item.UploadedAt);
  return (
    uploadedDate.getFullYear() < currentYear ||
    (uploadedDate.getFullYear() === currentYear &&
      uploadedDate.getMonth() < currentMonth)
  );
});


  return (
    
    <div>
      <Card
        title={
          <div className="flex justify-between items-center">
            <span className="font-semibold text-[16px] leading-[100%] tracking-[0%] text-justify text-[#000833] ">Dashboard</span>
            <div className="flex items-center gap-4">
              <div className="-mr-1">
                <InfoCircleOutlined className="mr-2" />
                <MoreOutlined />
              </div>
            </div>
          </div>
        }>
    <div className="bg-[#efecfc]  border border-blue-300 rounded-md shadow-md w-full mx-auto -mt-3">

      <div className="flex flex-wrap justify-between gap-0">
        {/* Total Rebate */}
        <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[25%]">
          <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
            Pending Uploads
          </div>
          <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
           7
          </div>
        </div>

         <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[25%]">
          <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
            Files in Audit
          </div>
          <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
           5
          </div>
        </div>

         <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[25%]">
          <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
            Files Awaiting Approvals 
          </div>
          <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
           8
          </div>
        </div>

         <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[25%]">
          <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
            Recent Exceptions
          </div>
          <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
           4
          </div>
        </div>
      </div>
    </div>
    <div className="mt-10">
    <span className="cardtitle mt-20 ">
      Recent Files
    </span>
    <Table
      columns={columns}
      dataSource={currentMonthData}
    //   pagination={pagination}
    //   onChange={handleTableChange}
    //   loading={loading}
      scroll={{ x: "max-content" }}
      rowKey="id"
      size="middle"
      className="custom-table user-tbl"
      pagination={{
      pageSize: recentPagination,
      showSizeChanger: true,
      showTotal: (total) => `Total ${total} accounts`,
      onShowSizeChange: (current, size) => {
        setRecentPagination(size);
      },
    }}
    />
    </div>

    <div className="mt-10">
    <span className="cardtitle mt-20 ">
      Upload Logs
    </span>
    <Table
      columns={columns}
      dataSource={previousMonthsData}
    //   pagination={pagination}
    //   onChange={handleTableChange}
    //   loading={loading}
      scroll={{ x: "max-content" }}
      rowKey="id"
      size="middle"
      className="custom-table user-tbl"
      // pagination={false}
      pagination={{
      pageSize: pagination,
      showSizeChanger: true,
      showTotal: (total) => `Total ${total} accounts`,
      onShowSizeChange: (current, size) => {
        setPagination(size);
      },
    }}
    />
    </div>
    </Card>
    </div>

    
    
  );
};

export default AutoDashboard;
